export class GraphqlMiddlewareCache {
  cache;
  keys;
  maxSize;
  constructor(maxSize = 100) {
    this.cache = {};
    this.keys = [];
    this.maxSize = maxSize;
  }
  set(key, value) {
    if (Object.prototype.hasOwnProperty.call(this.cache, key)) {
      const index = this.keys.indexOf(key);
      if (index > -1) {
        this.keys.splice(index, 1);
      }
    } else if (this.keys.length >= this.maxSize) {
      const oldestKey = this.keys.shift();
      if (oldestKey !== void 0) {
        delete this.cache[oldestKey];
      }
    }
    this.cache[key] = value;
    this.keys.push(key);
  }
  get(key) {
    const value = this.cache[key];
    if (value !== void 0) {
      const index = this.keys.indexOf(key);
      if (index > -1) {
        this.keys.splice(index, 1);
        this.keys.push(key);
      }
      return value;
    }
    return void 0;
  }
  purge() {
    this.cache = {};
  }
}
